module.exports = __webpack_public_path__ + "static/tagline-a2739d8176f8ed84c183d8d6c11a896c.mp4";